module.exports = "/4/4-dia-chi-cua-bien/index.html.3682aca5f03dfa10d2a8c89ed89f08a3.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30022.md
 ** module id = 551
 ** module chunks = 0
 **/